import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { getFormValues, change } from 'redux-form';

import { Filter, Main } from 'Containers/';
import { FoodBasedAnalysisFieldEnum } from 'Common/FieldEnum';
import { MenuMealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { FOOD_BASED_ANALYSIS_FORM_NAME } from 'Common/FormEnum';
import { withReportSubscription } from 'State/report/withReportSubscription';
import { errorToast } from 'Common/ToastHelper';

import { FoodBasedAnalysisReportForm } from '../components/FoodBasedAnalysisReportForm';
import { SortByEnum, ComponentEnum } from '../helpers/FoodBasedAnalysisHelpers';
import * as FoodBasedAnalysisActions from '../state/actions';
import * as FoodBasedAnalysisSelectors from '../state/selectors';

class FoodBasedAnalysisReportContainer extends Component {
  componentDidMount() {
    const { getNutritionStandards } = this.props;

    getNutritionStandards();
  }

  componentDidUpdate(prevProps) {
    const {
      formValues: {
        [FoodBasedAnalysisFieldEnum.Site]: Site,
        [FoodBasedAnalysisFieldEnum.FromDate]: FromDate,
        [FoodBasedAnalysisFieldEnum.ToDate]: ToDate,
        [FoodBasedAnalysisFieldEnum.MealType]: MealType,
        [FoodBasedAnalysisFieldEnum.NutritionStandard]: NutritionStandard,
      },
      getCycleMenus,
      clearGetCycleMenusResult,
      change,
    } = this.props;

    const {
      [FoodBasedAnalysisFieldEnum.Site]: prevSite,
      [FoodBasedAnalysisFieldEnum.FromDate]: prevFromDate,
      [FoodBasedAnalysisFieldEnum.ToDate]: prevToDate,
      [FoodBasedAnalysisFieldEnum.MealType]: prevMealType,
      [FoodBasedAnalysisFieldEnum.NutritionStandard]: prevNutritionStandard,
    } = prevProps.formValues || {};

    if (
      Site !== prevSite ||
      FromDate !== prevFromDate ||
      ToDate !== prevToDate ||
      MealType !== prevMealType
    ) {
      //clear
      clearGetCycleMenusResult();

      change(FoodBasedAnalysisFieldEnum.NutritionStandard, null);
      change(FoodBasedAnalysisFieldEnum.Menu, null);

      if (Site && FromDate && ToDate && MealType !== null) {
        const params = {
          FromDate,
          ToDate,
          Site,
          MealType,
          GetActiveAndInactive: true,
        };

        getCycleMenus(params);
      }
    }

    if (NutritionStandard !== prevNutritionStandard) {
      change(FoodBasedAnalysisFieldEnum.Menu, null);
    }

    if (errorToast(this.props, prevProps, 'getCycleMenusErrors')) {
      clearGetCycleMenusResult();
    }
  }

  handleSubmit = (values) => {
    const { getReport } = this.props;

    const { ...params } = values;

    if (values[FoodBasedAnalysisFieldEnum.SortBy] !== SortByEnum.Component) {
      params[FoodBasedAnalysisFieldEnum.SortByComponent] = null;
    }

    getReport('reports/FoodBasedAnalysis', params);
  };

  getMainProps = () => {
    const {
      reportFetching,
      formValues: { [FoodBasedAnalysisFieldEnum.Menu]: cycleMenu },
    } = this.props;

    const toolbox = {
      shown: true,
      formName: FOOD_BASED_ANALYSIS_FORM_NAME,
      saveButtonProps: {
        content: 'View',
        loading: reportFetching,
        disabled: reportFetching || !cycleMenu,
      },
    };

    return { toolbox };
  };

  render() {
    const {
      nutritionStandardsOptions,
      getNutritionStandardsLoading,
      cycleMenuOptions,
      getCycleMenusLoading,
      reportFetching,
    } = this.props;

    const today = moment().format(DATE_FORMAT_FOR_UI);

    return (
      <React.Fragment>
        <Filter title="Food Based Analysis" />

        <Main shouldUsePageWidth {...this.getMainProps()}>
          <FoodBasedAnalysisReportForm
            onSubmit={this.handleSubmit}
            nutritionStandards={nutritionStandardsOptions}
            nutritionStandardsLoading={getNutritionStandardsLoading}
            cycleMenus={cycleMenuOptions}
            cycleMenusLoading={getCycleMenusLoading}
            loading={reportFetching}
            initialValues={{
              [FoodBasedAnalysisFieldEnum.FromDate]: today,
              [FoodBasedAnalysisFieldEnum.ToDate]: today,
              [FoodBasedAnalysisFieldEnum.MealType]:
                MenuMealTypesEnum.Breakfast,
              [FoodBasedAnalysisFieldEnum.NutritionStandard]: 0,
              [FoodBasedAnalysisFieldEnum.NumDays]: 5,
              [FoodBasedAnalysisFieldEnum.SortBy]: SortByEnum.Recipe,
              [FoodBasedAnalysisFieldEnum.SortByComponent]: ComponentEnum.Fruit,
            }}
          />
        </Main>
      </React.Fragment>
    );
  }
}

const FoodBasedAnalysisReportReport = withReportSubscription(
  FoodBasedAnalysisReportContainer
);

FoodBasedAnalysisReportReport.path = '/foodbasedanalysis';

const mapStateToProps = (state) => {
  return {
    formValues: getFormValues(FOOD_BASED_ANALYSIS_FORM_NAME)(state) || {},

    getCycleMenusLoading: FoodBasedAnalysisSelectors.getCycleMenusLoading(
      state
    ),
    getCycleMenusResult: FoodBasedAnalysisSelectors.getCycleMenusResult(state),
    getCycleMenusErrors: FoodBasedAnalysisSelectors.getCycleMenusErrors(state),

    getNutritionStandardsLoading: FoodBasedAnalysisSelectors.getNutritionStandardsLoading(
      state
    ),
    getNutritionStandardsErrors: FoodBasedAnalysisSelectors.getNutritionStandardsErrors(
      state
    ),

    nutritionStandardsOptions: FoodBasedAnalysisSelectors.nutritionStandardOptions(
      state
    ),
    cycleMenuOptions: FoodBasedAnalysisSelectors.cycleMenuOptions(state),
  };
};

const mapDispatchToProps = {
  change: (...args) => change(FOOD_BASED_ANALYSIS_FORM_NAME, ...args),

  getNutritionStandards: FoodBasedAnalysisActions.getNutritionStandards,
  clearGetNutritionStandardsResult:
    FoodBasedAnalysisActions.clearGetNutritionStandardsResult,

  getCycleMenus: FoodBasedAnalysisActions.getCycleMenus,
  clearGetCycleMenusResult: FoodBasedAnalysisActions.clearGetCycleMenusResult,
};

export const FoodBasedAnalysisReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(FoodBasedAnalysisReportReport);



// WEBPACK FOOTER //
// ./src/pages/reports/menus/foodbasedanalysisreport/containers/FoodBasedAnalysisReport.js